import React from 'react';
import { CHAT_CATEGORIES } from './chatCategories';

export const CategoryTabs = ({ active, onChange, language }) => (
  <div className="border-b border-border/50 bg-background/60 backdrop-blur-sm" data-testid="chat-category-tabs">
    <div className="flex gap-2 overflow-x-auto px-4 py-3 no-scrollbar">
      {CHAT_CATEGORIES.map((c) => {
        const isActive = c.id === active;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            data-testid={`chat-category-${c.id}`}
            aria-pressed={isActive}
            className={`flex shrink-0 items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors duration-200 ${
              isActive
                ? 'border-primary bg-primary text-primary-foreground shadow-sm shadow-primary/20'
                : 'border-border/60 bg-muted/40 text-muted-foreground hover:border-primary/40 hover:text-foreground'
            }`}
          >
            <c.icon className="h-3.5 w-3.5" />
            {language === 'sw' ? c.sw : c.en}
          </button>
        );
      })}
    </div>
  </div>
);
